import React, {PureComponent} from "react";
import {GridColumn, Button, Icon} from "semantic-ui-react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import { Select } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import * as showSeasonActions from "../../store/showSeason/showSeasonActions";
import { selectCountry } from '../../store/country/countryActions';

const numbersToWords = {
  2: 'Two',
  3: 'Three',
  4: 'Four',
  5: 'Five',
  6: 'Six',
  7: 'Seven',
  8: 'Eight',
  9: 'Nine',
};

class ApplyNow extends PureComponent {
  static propTypes = {
    season: PropTypes.object.isRequired,
    setShowApplicants: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    show: PropTypes.object,
    onApply: PropTypes.func,
    countries: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string,
        value: PropTypes.string
      })
    ).isRequired
  };

  constructor(props) {
    super(props);
     this.state = {
       showCountry: false,
       showCountryTeam: false
    };
  }

  redirectToApply = () => {
    const { onApply, history } = this.props;

    if (typeof onApply === "function") {
      return onApply();
    }

    history.push("/apply");
  };

  apply = (numberOfApplicants, isTeam) => {
    this.props.setShowApplicants(numberOfApplicants);
    if (this.props.countries.length > 1) {
      if (!isTeam) {
        this.setState({showCountryTeam: false, showCountry: true});
      } else {
        this.setState({showCountryTeam: true, showCountry: false});
      }
    } else {
      this.props.selectCountry(this.props.countries[0].value);
      this.redirectToApply();
    }
  };

  handleCountrySelect = (e, { value }) => {
    if (value) {
      this.props.selectCountry(value);
      this.redirectToApply();
    }
  };

  renderCountrySelect() {
    return (
      <Select
        fluid
        label="Country"
        options={this.props.countries}
        onChange={this.handleCountrySelect}
        placeholder="Country"
      />
    )
  }

  renderApplyButtonSection() {
    const { season } = this.props;
    let divClass = this.state.showCountry ? 'margin-top-apply' : '';
    const IsGermanShoreShow =
      process.env.REACT_APP_IS_GERMAN_SHORE_SHOW === 'true';
    if (season.activelyCastingC) {
      if (season.numberOfApplicantsC <= 1 || season.onlyTeamC) {
        return (
          <div>
            <Button
              onClick={() => {
                this.apply(1, false);
              }}
              className="ui huge fluid primary right labeled icon"
              style={{ backgroundColor: `#${season.hexColorCodeC}` }}
            >
              <Icon className="right chevron" />
              {IsGermanShoreShow ? 'Bewirb dich jetzt' : 'Apply Now'}
            </Button>
            {this.state.showCountry &&
              this.renderCountrySelect()
            }
          </div>
        );
      }

      return (
        <div id="applyCard" className="ui fluid card">
          <div className="content inverted">
            <div className="header">
              <h2>Apply Now!</h2>
            </div>
          </div>
          <div className="content shaded padded">
            <div>
              <Button
                onClick={() => {
                  this.apply(+season.numberOfApplicantsC, true);
                }}
                className="ui huge fluid primary right labeled icon"
                style={{ backgroundColor: `#${season.hexColorCodeC}` }}
              >
                <Icon className="right chevron" />
                Team of {numbersToWords[season.numberOfApplicantsC]}
              </Button>
              {this.state.showCountryTeam &&
                this.renderCountrySelect()
              }
            </div>
            <div className={divClass}>
              <Button
                onClick={() => {
                  this.apply(1, false);
                }}
                className="ui huge fluid primary right labeled icon"
                style={{ backgroundColor: `#${season.hexColorCodeC}` }}
              >
                <Icon className="right chevron" />
                Singles
              </Button>
              {this.state.showCountry &&
                this.renderCountrySelect()
              }
            </div>
          </div>
        </div>
      );
    }
  }

  render() {
    const render = this.renderApplyButtonSection();

    return (
      <React.Fragment>
        <GridColumn className="ui sixteen wide mobile five wide computer right floated tablet-up">
          {render}
        </GridColumn>
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => ({
  countries: state.country.countries.map(country => ({
    text: country.name,
    value: country.sfId
  }))
});

const mapDispatchToProps = dispatch => ({
  selectCountry: countrySfId => dispatch(selectCountry(countrySfId)),
  setShowApplicants: applicants =>
    dispatch(showSeasonActions.setShowApplicants(applicants))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ApplyNow)
);



// WEBPACK FOOTER //
// ./src/components/common/ApplyNow.js